import {
  Home, Briefcase, Search, FileText, Bookmark, User, Building2, Store, SquarePen,
  List, BarChart3, MessageSquare, Star, ShieldCheck, LogOut, Menu, X, ArrowLeft,
  ArrowRight, ExternalLink, MapPin, Banknote, Clock, Calendar, Phone, Mail, File,
  FileUser, Award, Camera, Upload, Pencil, Trash2, Plus, SlidersHorizontal, Check,
  CheckCircle2, AlertTriangle, AlertCircle, Info, Eye, EyeOff, Sparkles,
  ChevronDown, ChevronRight, MoreHorizontal, Package, Warehouse, Image, TrendingUp,
  CreditCard, Users, Scissors, Lock, LayoutGrid, Compass, Heart, Sparkle, Settings2, MessageCircle, Ban, Download, History, UserCheck,
} from "lucide-react";

// Single source of truth for icons. Pages use semantic names
// (<Icon name="location" />) and never import lucide directly, so an icon
// swap or a library change happens in this one file.
const ICONS = {
  home: Home,
  jobs: Briefcase,
  briefcase: Briefcase,
  search: Search,
  applications: FileText,
  saved: Bookmark,
  "saved-filled": Bookmark,
  profile: User,
  company: Building2,
  marketplace: Store,
  post: SquarePen,
  listings: List,
  analytics: BarChart3,
  messages: MessageSquare,
  shortlist: Star,
  admin: ShieldCheck,
  signout: LogOut,
  menu: Menu,
  close: X,
  back: ArrowLeft,
  forward: ArrowRight,
  external: ExternalLink,
  location: MapPin,
  salary: Banknote,
  clock: Clock,
  calendar: Calendar,
  phone: Phone,
  mail: Mail,
  document: File,
  cv: FileUser,
  certificate: Award,
  camera: Camera,
  upload: Upload,
  edit: Pencil,
  delete: Trash2,
  add: Plus,
  filter: SlidersHorizontal,
  check: Check,
  "check-circle": CheckCircle2,
  alert: AlertTriangle,
  "alert-circle": AlertCircle,
  info: Info,
  eye: Eye,
  "eye-off": EyeOff,
  sparkles: Sparkles,
  "chevron-down": ChevronDown,
  "chevron-right": ChevronRight,
  more: MoreHorizontal,
  product: Package,
  rental: Warehouse,
  image: Image,
  trend: TrendingUp,
  payment: CreditCard,
  people: Users,
  scissors: Scissors,
  lock: Lock,
  overview: LayoutGrid,
  compass: Compass,
  heart: Heart,
  "heart-filled": Heart,
  sparkle: Sparkle,
  settings: Settings2,
  chat: MessageCircle,
  ban: Ban,
  download: Download,
  history: History,
  verify: UserCheck,
};

// True when `name` is a registered semantic icon name (lets components accept
// either an icon name or already-rendered content while pages migrate).
export const isIconName = (name) => typeof name === "string" && Object.prototype.hasOwnProperty.call(ICONS, name);

// Names whose glyph should render solid rather than outlined.
const FILLED = new Set(["saved-filled", "heart-filled", "sparkle"]);

export default function Icon({ name, size = 20, strokeWidth = 1.75, label, className, ...rest }) {
  const Glyph = ICONS[name] || ICONS.briefcase;
  return (
    <Glyph
      size={size}
      strokeWidth={strokeWidth}
      fill={FILLED.has(name) ? "currentColor" : "none"}
      className={className}
      aria-hidden={label ? undefined : "true"}
      aria-label={label}
      role={label ? "img" : undefined}
      focusable="false"
      {...rest}
    />
  );
}
